import css from './ReceiptNotReady.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonWhiteBlack } from 'components/Actions/Action'
import Head from 'components/common/Head'
import Img from 'components/Media/Img'

interface Props {
  codeTransaction: string
}

const ReceiptNotReady: React.FC<Props> = (props) => {
  const { codeTransaction } = props

  const { t } = useTranslation()

  return (
    <>
      <Head>
        <link href="https://fonts.googleapis.com/css?family=Nunito Sans" rel="stylesheet" />
      </Head>
      <div className={css.wrapper}>
        <div className={css.box}>
          <div className={css.logo}>
            <Img alt="TicketSMS Logo" src="/logo/TicketSms_logo.svg" />
          </div>
          <div className={css.transaction}>
            <div className={css.data}>
              <div className={css.left}>
                <span>{t('receipt:transactionCode')}</span>
              </div>
              <div className={css.right}>
                <span>{codeTransaction}</span>
              </div>
            </div>
          </div>
          <div className={css.image}>
            <Img alt="Live your time" src="/receipt/not_ready.svg" />
          </div>
          <div className={css.text}>
            <span className={css.in_progress}>{t('receipt:receipt_in_progress')}</span>
            <span className={css.wait_for}>{t('receipt:wait_for_refresh')}</span>
          </div>
          <div className={css.button}>
            <ButtonWhiteBlack
              className={css.refresh_button}
              onClick={() => {
                window.location.reload()
              }}
            >
              <h5>{t('receipt:refresh_page')}</h5>
            </ButtonWhiteBlack>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReceiptNotReady
